import {DomainStore, deleteModel, fetchModels} from 'shared/store';
import {action, observable, computed} from 'mobx';
import _ from 'lodash';
import {types, endpoints, t} from 'shared/core';
import {Goal} from 'stores/performance_goals';
import {successAlert} from 'shared/tools';

class GoalListState {
  store = new DomainStore();
  match;
  history;
  canCreateGoals;
  agent;

  @observable title;
  @observable selectedGoal = {};
  @observable errors = {};
  @observable interactiveContextState = {};
  @observable duplicateAssignees = [];
  @observable availableParentGoals = [];

  receiveProps({match, history, canCreateGoals}) {
    this.match = match;
    this.history = history;
    this.canCreateGoals = canCreateGoals;
  }

  @action setInteractiveAgent(agent) {
    this.agent = agent;
  }

  goToNewGoalPage() {
    if (this.match.params.employeeId) {
      this.history.push(`${this.match.url}/new`);
    } else {
      this.history.push('/new');
    }
  }

  @action changeDuplicateAssignees(employees) {
    this.duplicateAssignees = employees;
  }

  @action async openDuplicateGoalModal() {
    await this.fetchAvailableParentGoals();
  }

  @action async deleteGoal(goal) {
    await deleteModel(goal);
  }

  @action async goToGoal(goal) {
    await this.history.push(`/view/${goal.id}`);
  }

  @action updateInteractiveContextState(interactiveContextState) {
    this.interactiveContextState = interactiveContextState;
  }

  @action async fetchSubgoals(goal) {
    if (goal.subgoals && goal.subgoals.length > 0) return;

    const store = new DomainStore();
    await store._compose([endpoints.PERFORMANCE_GOALS.GOAL.SUBGOALS.with(goal.id)]);
    goal.subgoals = store._getAll(types.PERFORMANCE_GOALS.GOAL, Goal);
  }

  @action updateDuplicatingGoal(attributes) {
    this.selectedGoal.merge(attributes);
  }

  @action async fetchAvailableParentGoals() {
    const parentGoals = await fetchModels(
      endpoints.PERFORMANCE_GOALS.PARENT_GOALS_FOR_GOAL.with(this.selectedGoal.id),
      types.PERFORMANCE_GOALS.GOAL
    );
    this.availableParentGoals = parentGoals.map(model => new Goal(model));
  }

  @action async duplicateSelectedGoal() {
    const {model, errors} = await this.store.post(
      endpoints.PERFORMANCE_GOALS.GOAL.DUPLICATE.with(this.selectedGoal.id),
      types.PERFORMANCE_GOALS.GOAL,
      {
        ..._.pick(this.selectedGoal, ['startDate', 'endDate', 'parentGoal']),
        assignees: this.duplicateAssignees
      }
    );

    this.errors = errors;
    if (model) {
      this.agent.refresh();
      successAlert(t('goals.Goal duplicated'));
      this.closeDuplicateGoalModal();
    }
  }

  @computed get canViewNestedGoals() {
    const search = this.interactiveContextState.filter.get('search') || '';
    const goal_status = this.interactiveContextState.filter.get('goal_status') || [];

    const isSearchEmpty = _.isEmpty(search);
    const isGoalStatusEmpty = _.isEmpty(goal_status);
    const isGoalStatusAll = goal_status.includes('all');

    return isSearchEmpty && (isGoalStatusEmpty || isGoalStatusAll);
  }

  customLinksFor(model) {
    const links = [];

    if (model.hasLink('duplicate')) {
      links.push(
        {
          order: 1,
          text: 'goals.Duplicate',
          action: goal => this.openDuplicateGoalModal(goal)
        }
      );
    }

    return links;
  }
}

export default GoalListState;
